import React from 'react'

import Svg, {
  Defs,
  G,
  LinearGradient,
  Mask,
  Path,
  Stop,
} from 'react-native-svg'

const TrainingCertificate = ({
  width,
  height,
  ...props
}: {
  width: number
  height?: number
}) => {
  return (
    <Svg
      width={width}
      height={320}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1258 906"
      {...props}
    >
      <Mask
        id="mask0_3613_24200"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={1258}
        height={906}
      >
        <Path d="M1258 0H0V906H1258V0Z" fill="white" />
      </Mask>
      <G mask="url(#mask0_3613_24200)">
        <Path
          d="M1256.81 1.33667H1.03918V904.44H1256.81V1.33667Z"
          fill="url(#paint0_linear_3613_24200)"
        />
        <Path
          d="M1310.36 529.193L567.77 217.069L1326.65 28.4055L1310.36 529.193Z"
          fill="url(#paint1_linear_3613_24200)"
        />
        <Path
          d="M-69.0601 529.193L673.531 217.069L-85.351 28.4055L-69.0601 529.193Z"
          fill="url(#paint2_linear_3613_24200)"
        />
        <G
          style={{
            mixBlendMode: 'color-burn',
          }}
        >
          <Path
            d="M-28.5367 -236.414V218.108L608.85 397.6L1321.86 218.108V-236.414H-28.5367Z"
            fill="#595959"
          />
        </G>
        <Path
          d="M-28.5367 -236.414V218.108L608.85 397.6L1321.86 218.108V-236.414H-28.5367Z"
          fill="url(#paint3_linear_3613_24200)"
        />
        <Path
          d="M-28.5367 -278.484V176.039L608.85 389.877L1321.86 176.039V-278.484H-28.5367Z"
          fill="url(#paint4_linear_3613_24200)"
        />
        <Path
          style={{
            mixBlendMode: 'screen',
          }}
          opacity={0.7}
          d="M-28.5367 -471.566V114.253L608.85 389.877L1321.86 114.253V-471.566H-28.5367Z"
          fill="url(#paint5_linear_3613_24200)"
        />
        <Path
          d="M1226.79 878.412H31.097V27.4028H1226.79V878.412ZM32.9525 876.555H1224.94V29.2594H32.9525V876.555Z"
          fill="url(#paint6_linear_3613_24200)"
        />
        <Path
          d="M444.021 452.072C445.06 452.963 445.579 454.3 445.579 456.119C445.579 457.939 445.06 459.275 443.984 460.092C442.908 460.946 441.312 461.355 439.159 461.355H437.193V465.439H433.927V450.735H439.122C441.386 450.735 443.019 451.181 444.058 452.035L444.021 452.072ZM441.609 457.864C442.017 457.419 442.202 456.787 442.202 455.933C442.202 455.079 441.943 454.485 441.423 454.114C440.904 453.743 440.124 453.594 439.048 453.594H437.193V458.533H439.382C440.495 458.533 441.201 458.31 441.609 457.864Z"
          fill="#00173C"
        />
        <Path
          d="M466.36 455.636C466.36 457.976 465.433 459.498 463.577 460.204L467.288 465.476H463.243L459.978 460.798H457.714V465.476H454.448V450.772H460.015C462.316 450.772 463.911 451.144 464.913 451.923C465.878 452.703 466.36 453.928 466.36 455.636ZM462.427 457.382C462.835 457.01 463.021 456.453 463.021 455.636C463.021 454.82 462.798 454.3 462.39 454.003C461.982 453.706 461.239 453.557 460.2 453.557H457.751V457.901H460.126C461.239 457.901 462.019 457.716 462.427 457.344V457.382Z"
          fill="#00173C"
        />
        <Path
          d="M488.218 463.397C486.733 464.845 484.915 465.588 482.726 465.588C480.536 465.588 478.718 464.845 477.234 463.397C475.749 461.949 475.007 460.129 475.007 457.976C475.007 455.822 475.749 454.003 477.234 452.554C478.718 451.106 480.536 450.364 482.726 450.364C484.915 450.364 486.733 451.106 488.218 452.554C489.702 454.003 490.444 455.822 490.444 457.976C490.444 460.129 489.702 461.949 488.218 463.397ZM487.105 457.976C487.105 456.676 486.696 455.562 485.843 454.634C484.989 453.706 483.987 453.26 482.763 453.26C481.538 453.26 480.499 453.706 479.683 454.634C478.866 455.562 478.421 456.676 478.421 457.976C478.421 459.275 478.829 460.389 479.683 461.317C480.536 462.246 481.538 462.691 482.763 462.691C483.987 462.691 485.026 462.246 485.843 461.317C486.696 460.389 487.105 459.275 487.105 457.976Z"
          fill="#00173C"
        />
        <Path
          d="M503.395 461.652C503.952 462.32 504.694 462.654 505.585 462.654C506.476 462.654 507.255 462.32 507.774 461.652C508.331 460.983 508.591 460.055 508.591 458.867V450.772H511.856V458.978C511.856 461.095 511.263 462.728 510.075 463.88C508.888 465.031 507.403 465.588 505.548 465.588C503.692 465.588 502.208 464.993 501.02 463.88C499.833 462.728 499.239 461.095 499.239 458.978V450.772H502.505V458.867C502.505 460.055 502.765 460.983 503.321 461.652H503.395Z"
          fill="#00173C"
        />
        <Path
          d="M532.786 452.666C534.196 453.966 534.901 455.748 534.901 458.013C534.901 460.278 534.233 462.097 532.86 463.434C531.487 464.771 529.409 465.439 526.626 465.439H521.616V450.735H526.811C529.446 450.735 531.45 451.366 532.823 452.666H532.786ZM530.374 461.392C531.19 460.649 531.561 459.535 531.561 458.087C531.561 456.639 531.153 455.525 530.374 454.745C529.557 453.966 528.333 453.594 526.663 453.594H524.845V462.543H526.923C528.407 462.543 529.557 462.172 530.374 461.392Z"
          fill="#00173C"
        />
        <Path
          d="M544.03 465.439V450.735H547.296V462.506H553.567V465.439H544.03Z"
          fill="#00173C"
        />
        <Path
          d="M567.297 465.439H564.032V459.647L558.948 450.772H562.51L565.665 456.23L568.856 450.772H572.418L567.335 459.647V465.439H567.297Z"
          fill="#00173C"
        />
        <Path
          d="M602.217 452.072C603.256 452.963 603.776 454.3 603.776 456.119C603.776 457.939 603.256 459.275 602.18 460.092C601.104 460.946 599.508 461.355 597.356 461.355H595.389V465.439H592.123V450.735H597.319C599.582 450.735 601.215 451.181 602.254 452.035L602.217 452.072ZM599.805 457.864C600.213 457.419 600.399 456.787 600.399 455.933C600.399 455.079 600.139 454.485 599.619 454.114C599.1 453.743 598.321 453.594 597.244 453.594H595.389V458.533H597.578C598.655 458.533 599.397 458.31 599.805 457.864Z"
          fill="#00173C"
        />
        <Path
          d="M624.52 455.636C624.52 457.976 623.592 459.498 621.736 460.204L625.447 465.476H621.402L618.137 460.798H615.873V465.476H612.608V450.772H618.174C620.475 450.772 622.07 451.144 623.072 451.923C624.074 452.703 624.52 453.928 624.52 455.636ZM620.586 457.382C620.994 457.01 621.18 456.453 621.18 455.636C621.18 454.82 620.957 454.3 620.549 454.003C620.141 453.706 619.399 453.557 618.36 453.557H615.91V457.901H618.322C619.436 457.901 620.215 457.716 620.623 457.344L620.586 457.382Z"
          fill="#00173C"
        />
        <Path
          d="M644.781 450.735V453.668H637.471V456.676H644.039V459.461H637.471V462.506H645.004V465.402H634.168V450.698H644.744L644.781 450.735Z"
          fill="#00173C"
        />
        <Path
          d="M657.658 453.668C657.361 453.928 657.176 454.263 657.176 454.708C657.176 455.154 657.361 455.488 657.769 455.748C658.14 456.008 659.031 456.305 660.441 456.639C661.851 456.973 662.928 457.493 663.67 458.198C664.449 458.867 664.82 459.906 664.82 461.206C664.82 462.506 664.338 463.582 663.336 464.399C662.334 465.216 661.035 465.625 659.439 465.625C657.101 465.625 655.023 464.771 653.168 463.025L655.135 460.649C656.73 462.023 658.178 462.728 659.514 462.728C660.107 462.728 660.59 462.58 660.924 462.32C661.258 462.06 661.443 461.726 661.443 461.28C661.443 460.835 661.258 460.501 660.887 460.241C660.516 459.981 659.81 459.721 658.734 459.461C657.027 459.052 655.766 458.533 654.986 457.864C654.207 457.196 653.799 456.193 653.799 454.782C653.799 453.371 654.281 452.295 655.32 451.552C656.322 450.809 657.584 450.438 659.068 450.438C660.033 450.438 661.035 450.587 662 450.921C662.965 451.255 663.818 451.738 664.56 452.332L662.89 454.745C661.629 453.78 660.293 453.297 658.957 453.297C658.4 453.297 657.992 453.408 657.658 453.668Z"
          fill="#00173C"
        />
        <Path
          d="M684.525 450.735V453.668H677.215V456.676H683.783V459.461H677.215V462.506H684.748V465.402H673.949V450.698H684.525V450.735Z"
          fill="#00173C"
        />
        <Path
          d="M704.23 450.735H707.496V465.439H704.23L697.254 456.231V465.439H693.988V450.735H697.068L704.267 460.204V450.735H704.23Z"
          fill="#00173C"
        />
        <Path
          d="M723.638 453.594V465.439H720.373V453.594H716.216V450.772H727.794V453.594H723.638Z"
          fill="#00173C"
        />
        <Path
          d="M747.091 450.735V453.668H739.781V456.676H746.349V459.461H739.781V462.506H747.314V465.402H736.478V450.698H747.054L747.091 450.735Z"
          fill="#00173C"
        />
        <Path
          d="M767.761 452.666C769.171 453.966 769.876 455.748 769.876 458.013C769.876 460.278 769.208 462.097 767.835 463.434C766.462 464.771 764.384 465.439 761.601 465.439H756.591V450.735H761.786C764.421 450.735 766.425 451.366 767.798 452.666H767.761ZM765.349 461.392C766.165 460.649 766.573 459.535 766.573 458.087C766.573 456.639 766.165 455.525 765.349 454.745C764.532 453.966 763.308 453.594 761.638 453.594H759.82V462.543H761.898C763.382 462.543 764.532 462.172 765.349 461.392Z"
          fill="#00173C"
        />
        <Path
          d="M797.04 453.594V465.439H793.774V453.594H789.618V450.772H801.196V453.594H797.04Z"
          fill="#00173C"
        />
        <Path
          d="M821.829 463.397C820.345 464.845 818.526 465.588 816.337 465.588C814.147 465.588 812.329 464.845 810.845 463.397C809.36 461.949 808.618 460.129 808.618 457.976C808.618 455.822 809.36 454.003 810.845 452.554C812.329 451.106 814.147 450.364 816.337 450.364C818.526 450.364 820.345 451.106 821.829 452.554C823.313 454.003 824.056 455.822 824.056 457.976C824.056 460.129 823.313 461.949 821.829 463.397ZM820.716 457.976C820.716 456.676 820.308 455.562 819.454 454.634C818.601 453.706 817.599 453.26 816.374 453.26C815.149 453.26 814.11 453.706 813.294 454.634C812.44 455.562 812.032 456.676 812.032 457.976C812.032 459.275 812.44 460.389 813.294 461.317C814.147 462.246 815.149 462.691 816.374 462.691C817.599 462.691 818.638 462.246 819.454 461.317C820.27 460.389 820.716 459.275 820.716 457.976Z"
          fill="#00173C"
        />
        <Path
          d="M426.901 106.393C423.101 102.564 421.216 97.5629 421.216 91.3045C421.216 85.0464 423.101 80.0452 426.901 76.2162C430.698 72.4155 435.726 70.5006 441.979 70.5006C447.092 70.5006 451.605 71.7868 455.546 74.3871L456.689 82.4457H456.173C455.345 79.1596 453.631 76.6447 451.089 74.8728C448.547 73.1013 445.523 72.2153 442.008 72.2153C437.01 72.2153 433.013 73.9586 430.015 77.4163C427.013 80.8739 425.528 85.4749 425.528 91.2187C425.528 96.9625 427.013 101.563 429.955 105.05C432.928 108.536 436.809 110.336 441.667 110.451C445.949 110.451 449.49 109.279 452.377 106.965C455.461 104.45 457.346 100.335 457.973 94.6481H458.429L457.743 103.621C454.288 109.308 448.918 112.137 441.667 112.137C435.641 112.108 430.727 110.165 426.927 106.364L426.901 106.393Z"
          fill="#EDEDED"
        />
        <Path
          d="M471.139 110.793C472.137 110.793 472.969 110.451 473.681 109.736C474.394 109.022 474.765 108.165 474.794 107.193V75.1301C474.679 74.2155 474.282 73.444 473.596 72.8153C472.909 72.1867 472.082 71.8722 471.139 71.8722H470.453L470.397 71.3008H487.159C488.332 71.3008 489.616 71.1864 491.015 70.958C492.417 70.7293 493.386 70.5006 493.958 70.2722V77.4734H493.386V76.4445C493.386 75.53 493.074 74.7588 492.444 74.1012C491.816 73.444 491.074 73.1012 490.187 73.0726H478.509V90.7616H488.161C488.933 90.733 489.56 90.4471 490.102 89.9042C490.644 89.3613 490.903 88.7041 490.903 87.9039V87.1038H491.475V96.1337H490.903V95.2763C490.903 94.5051 490.644 93.8761 490.132 93.3333C489.616 92.7904 488.989 92.5045 488.217 92.4759H478.479V109.593H486.647C489.475 109.593 491.616 108.965 493.1 107.707C494.585 106.45 495.813 104.564 496.815 102.106H497.386L494.073 111.365H470.338V110.793H471.083H471.139Z"
          fill="#EDEDED"
        />
        <Path
          d="M520.346 73.0726H516.691V107.193C516.691 108.193 517.036 109.022 517.748 109.736C518.461 110.451 519.318 110.794 520.346 110.794H521.032L521.088 111.365H508.553V110.794H509.295C510.293 110.794 511.121 110.451 511.837 109.765C512.549 109.079 512.92 108.25 512.95 107.25V75.4731C512.92 74.4728 512.549 73.644 511.837 72.9296C511.121 72.2152 510.293 71.8725 509.295 71.8725H508.553V71.301H524.001C527.46 71.301 530.198 72.2724 532.169 74.1872C534.143 76.1017 535.141 78.6166 535.141 81.674C535.141 84.7317 534.199 87.3896 532.314 89.6186C530.428 91.8475 528.142 92.9619 525.43 92.9619C526.001 93.2192 526.688 93.762 527.46 94.5336C528.228 95.3052 528.944 96.134 529.542 96.9627C532.829 101.649 534.971 104.535 535.939 105.65C536.941 106.736 537.624 107.479 538.054 107.879C538.481 108.279 538.938 108.679 539.424 109.05C539.91 109.422 540.426 109.736 540.912 109.965C542.025 110.508 543.194 110.765 544.452 110.765V111.337H541.309C539.683 111.337 538.14 111.051 536.741 110.451C535.342 109.851 534.254 109.251 533.572 108.622C532.855 107.993 532.258 107.393 531.742 106.793C531.23 106.193 529.801 104.221 527.486 100.877C525.174 97.5342 523.804 95.5911 523.43 95.1337C523.059 94.648 522.661 94.1905 522.231 93.7334C521.003 92.4476 519.804 91.7904 518.576 91.7904V91.2185C518.891 91.2471 519.292 91.2757 519.774 91.2757C520.26 91.2757 520.891 91.2757 521.604 91.2185C526.343 91.1046 529.315 89.1325 530.514 85.2746C530.744 84.5034 530.855 83.789 530.855 83.1314V81.8455C530.77 79.3024 530.113 77.2164 528.859 75.6732C527.601 74.1015 525.886 73.2727 523.775 73.1583C522.862 73.1297 521.719 73.1011 520.346 73.1011V73.0726Z"
          fill="#EDEDED"
        />
        <Path
          d="M580.121 76.3874C580.121 75.4732 579.81 74.6731 579.153 74.0158C578.496 73.3582 577.75 72.9869 576.867 72.9583H565.986V107.25C566.012 108.25 566.383 109.079 567.1 109.765C567.812 110.451 568.64 110.793 569.642 110.793H570.384V111.365H557.845V110.793H558.587C559.589 110.793 560.416 110.451 561.129 109.765C561.845 109.079 562.216 108.25 562.242 107.307V72.9583H551.362C550.449 72.9869 549.677 73.3582 549.05 74.0158C548.423 74.6731 548.107 75.4732 548.107 76.3874V77.3591L547.536 77.4163V70.2151C548.107 70.4434 549.105 70.6722 550.504 70.9009C551.903 71.1293 553.217 71.2436 554.39 71.2436H573.724C575.583 71.2436 577.153 71.1007 578.381 70.8151C579.609 70.5292 580.377 70.3295 580.637 70.2151V77.4163L580.066 77.3591V76.3874H580.121Z"
          fill="#EDEDED"
        />
        <Path
          d="M591.658 110.794C592.66 110.794 593.488 110.451 594.2 109.736C594.917 109.022 595.288 108.164 595.317 107.193V75.4159C595.288 74.4156 594.917 73.5872 594.2 72.901C593.488 72.2152 592.66 71.8725 591.658 71.8725H590.916V71.301H603.455V71.8725H602.713C601.715 71.8725 600.884 72.2152 600.171 72.901C599.459 73.5872 599.084 74.4156 599.058 75.4159V107.193C599.058 108.193 599.429 109.022 600.142 109.736C600.858 110.451 601.715 110.794 602.713 110.794H603.455V111.365H590.916V110.794H591.658Z"
          fill="#EDEDED"
        />
        <Path
          d="M639.555 71.9294V76.7304H638.984V75.8731C638.984 75.1015 638.728 74.4443 638.182 73.9014C637.64 73.3582 636.984 73.0726 636.186 73.0726H624.103V90.7616H633.759C634.527 90.733 635.158 90.4471 635.7 89.9042C636.241 89.3613 636.497 88.7323 636.497 87.9608V87.1038H637.069V96.1337H636.497V95.2763C636.497 94.5051 636.241 93.8761 635.729 93.3333C635.213 92.7904 634.586 92.5045 633.814 92.4759H624.103V107.193C624.103 108.193 624.474 109.022 625.19 109.736C625.903 110.451 626.76 110.793 627.758 110.793H628.5V111.365H615.965V110.793H616.707C617.705 110.793 618.537 110.451 619.249 109.736C619.962 109.022 620.333 108.165 620.362 107.193V75.1301C620.362 74.2155 619.991 73.444 619.249 72.8153C618.507 72.1867 617.65 71.8722 616.707 71.8722H616.021L615.965 71.3008H632.731C633.9 71.3008 635.213 71.1864 636.583 70.958C637.986 70.7293 638.954 70.5006 639.526 70.2722V71.9294H639.555Z"
          fill="#EDEDED"
        />
        <Path
          d="M653.378 110.794C654.377 110.794 655.204 110.451 655.92 109.736C656.633 109.022 657.004 108.164 657.034 107.193V75.4159C657.004 74.4156 656.633 73.5872 655.92 72.901C655.204 72.2152 654.377 71.8725 653.378 71.8725H652.636V71.301H665.172V71.8725H664.429C663.431 71.8725 662.604 72.2152 661.888 72.901C661.175 73.5872 660.804 74.4156 660.774 75.4159V107.193C660.774 108.193 661.145 109.022 661.862 109.736C662.574 110.451 663.431 110.794 664.429 110.794H665.172V111.365H652.636V110.794H653.378Z"
          fill="#EDEDED"
        />
        <Path
          d="M682.249 106.393C678.453 102.564 676.568 97.5629 676.568 91.3045C676.568 85.0464 678.453 80.0452 682.249 76.2162C686.049 72.4155 691.078 70.5006 697.331 70.5006C702.444 70.5006 706.957 71.7868 710.898 74.3871L712.041 82.4457H711.525C710.697 79.1596 708.983 76.6447 706.441 74.8728C703.899 73.1013 700.845 72.2153 697.36 72.2153C692.362 72.2153 688.361 73.9586 685.363 77.4163C682.364 80.8739 680.88 85.4749 680.88 91.2187C680.88 96.9625 682.364 101.563 685.307 105.05C688.276 108.536 692.161 110.336 697.015 110.451C701.301 110.451 704.841 109.279 707.725 106.965C710.812 104.45 712.697 100.335 713.325 94.6481H713.781L713.094 103.621C709.64 109.308 704.27 112.137 697.015 112.137C690.989 112.108 686.079 110.165 682.279 106.364L682.249 106.393Z"
          fill="#EDEDED"
        />
        <Path
          d="M763.273 110.794H763.734V111.365H750.853V110.794H751.365C752.167 110.794 752.764 110.537 753.165 110.022C753.566 109.508 753.766 109.022 753.766 108.565C753.766 108.107 753.681 107.65 753.536 107.193L749.881 97.4485H734.429L730.603 107.25C730.462 107.708 730.376 108.165 730.376 108.593C730.376 109.022 730.573 109.508 730.974 110.022C731.374 110.537 731.976 110.794 732.773 110.794H733.289V111.365H721.778V110.794H722.294C723.236 110.794 724.179 110.479 725.092 109.879C726.005 109.279 726.747 108.365 727.318 107.193L740.255 76.3874C741.657 73.3014 742.37 71.3294 742.37 70.5006H742.882L758.219 107.193C758.765 108.365 759.477 109.279 760.39 109.879C761.303 110.479 762.245 110.794 763.247 110.794H763.273ZM735.115 95.7338H749.194L742.34 77.3591L735.145 95.7338H735.115Z"
          fill="#EDEDED"
        />
        <Path
          d="M798.46 76.3874C798.46 75.4732 798.145 74.6731 797.488 74.0158C796.831 73.3582 796.089 72.9869 795.206 72.9583H784.322V107.25C784.351 108.25 784.722 109.079 785.435 109.765C786.151 110.451 786.979 110.793 787.977 110.793H788.723V111.365H776.184V110.793H776.926C777.924 110.793 778.755 110.451 779.468 109.765C780.18 109.079 780.551 108.25 780.581 107.307V72.9583H769.701C768.788 72.9869 768.016 73.3582 767.389 74.0158C766.758 74.6731 766.446 75.4732 766.446 76.3874V77.3591L765.875 77.4163V70.2151C766.446 70.4434 767.444 70.6722 768.843 70.9009C770.243 71.1293 771.556 71.2436 772.729 71.2436H792.063C793.918 71.2436 795.488 71.1007 796.716 70.8151C797.944 70.5292 798.716 70.3295 798.972 70.2151V77.4163L798.401 77.3591V76.3874H798.46Z"
          fill="#EDEDED"
        />
        <Path
          d="M809.998 110.793C810.999 110.793 811.827 110.451 812.54 109.736C813.256 109.022 813.627 108.165 813.656 107.193V75.1301C813.541 74.2155 813.141 73.444 812.454 72.8153C811.771 72.1867 810.94 71.8722 809.998 71.8722H809.315L809.255 71.3008H826.021C827.19 71.3008 828.478 71.1864 829.877 70.958C831.276 70.7293 832.248 70.5006 832.82 70.2722V77.4734H832.248V76.4445C832.248 75.53 831.933 74.7588 831.306 74.1012C830.675 73.444 829.933 73.1012 829.049 73.0726H817.367V90.7616H827.02C827.791 90.733 828.418 90.4471 828.964 89.9042C829.506 89.3613 829.762 88.7041 829.762 87.9039V87.1038H830.333V96.1337H829.762V95.2763C829.762 94.5051 829.506 93.8761 828.99 93.3333C828.478 92.7904 827.847 92.5045 827.079 92.4759H817.338V109.593H825.505C828.333 109.593 830.478 108.965 831.962 107.707C833.447 106.45 834.675 104.564 835.673 102.106H836.245L832.931 111.365H809.2V110.793H809.942H809.998Z"
          fill="#EDEDED"
        />
        <Path
          d="M527.066 150C521.741 150 518 153.691 518 158.889C518 164.088 521.741 167.778 527.066 167.778C532.391 167.778 536.132 164.088 536.132 158.889C536.132 153.691 532.391 150 527.066 150ZM527.066 153.431C530.131 153.431 532.235 155.666 532.235 158.889C532.235 162.112 530.131 164.347 527.066 164.347C524.001 164.347 521.896 162.112 521.896 158.889C521.896 155.666 524.001 153.431 527.066 153.431ZM548.593 157.486V153.691H557.659V150.26H544.748V167.518H548.593V160.917H555.788V157.486H548.593ZM585.75 153.691H590.868V150.26H576.762V153.691H581.906V167.518H585.75V153.691ZM603.199 161.514H606.108L609.615 167.518H614.135L610.005 161.124C612.395 160.423 613.615 158.655 613.615 155.9C613.615 152.183 611.407 150.26 607.095 150.26H599.354V167.518H603.199V161.514ZM603.199 158.083V153.691H606.939C608.836 153.691 609.719 154.393 609.719 155.9C609.719 157.382 608.836 158.083 606.939 158.083H603.199ZM635.514 167.518H639.644L632.292 150.26H628.578L621.227 167.518H625.253L626.422 164.607H634.345L635.514 167.518ZM630.396 154.679L633.046 161.306H627.721L630.344 154.679H630.396ZM647.834 167.518H651.678V150.26H647.834V167.518ZM672.278 167.518H676.901V150.26H673.187V161.852H673.135L666.615 150.26H661.341V167.518H665.056V154.705H665.108L672.278 167.518ZM686.572 167.518H690.417V150.26H686.572V167.518ZM711.016 167.518H715.64V150.26H711.925V161.852H711.873L705.353 150.26H700.08V167.518H703.794V154.705H703.846L711.016 167.518ZM734.038 153.431C736.376 153.431 738.298 154.107 739.805 155.562H739.987V151.352C738.35 150.416 736.454 150 733.882 150C728.012 150 724.271 153.457 724.271 158.889C724.271 164.321 728.012 167.778 733.882 167.778C736.454 167.778 738.35 167.363 739.987 166.427V157.953H732.48V161.176H736.272V164.114C735.571 164.269 734.844 164.347 734.038 164.347C730.48 164.347 728.168 162.216 728.168 158.889C728.168 155.562 730.48 153.431 734.038 153.431Z"
          fill="#C09236"
        />
        <Path
          d="M520.313 318.734C523.245 312.533 523.245 302.359 520.313 296.158C517.382 289.957 519.163 281.12 524.21 276.479C529.294 271.874 533.153 262.48 532.856 255.648C532.522 248.816 537.532 241.315 543.989 238.976C550.446 236.637 557.608 229.471 559.909 223.01C562.247 216.549 569.743 211.536 576.571 211.87C583.436 212.205 592.787 208.306 597.426 203.219C602.028 198.169 610.897 196.387 617.094 199.32C623.291 202.253 633.459 202.253 639.656 199.32C645.854 196.424 654.686 198.169 659.324 203.219C663.926 208.306 673.314 212.167 680.142 211.87C687.008 211.536 694.504 216.586 696.842 223.01C699.142 229.471 706.342 236.637 712.798 238.976C719.218 241.315 724.265 248.816 723.931 255.648C723.597 262.517 727.494 271.874 732.578 276.479C737.662 281.12 739.406 289.957 736.474 296.158C733.542 302.359 733.542 312.496 736.474 318.734C739.406 324.935 737.625 333.809 732.578 338.413C727.531 343.018 723.634 352.412 723.931 359.244C724.265 366.076 719.218 373.577 712.798 375.916C706.342 378.255 699.179 385.421 696.842 391.882C694.504 398.343 687.008 403.356 680.142 403.022C673.314 402.687 663.926 406.586 659.324 411.636C654.723 416.723 645.854 418.468 639.656 415.535C633.459 412.601 623.291 412.601 617.094 415.535C610.897 418.468 602.065 416.686 597.426 411.636C592.825 406.549 583.436 402.687 576.571 403.022C569.706 403.356 562.21 398.306 559.909 391.882C557.608 385.421 550.409 378.255 543.989 375.916C537.532 373.577 532.522 366.076 532.856 359.244C533.19 352.375 529.294 343.018 524.21 338.413C519.126 333.809 517.382 324.935 520.313 318.734Z"
          fill="url(#paint7_linear_3613_24200)"
        />
        <Path
          d="M724.562 307.483C724.562 360.618 681.515 403.727 628.412 403.727C575.309 403.727 532.225 360.618 532.225 307.483C532.225 254.348 575.272 211.239 628.412 211.239C681.553 211.239 724.562 254.348 724.562 307.483Z"
          fill="url(#paint8_linear_3613_24200)"
        />
        <Path
          d="M713.541 307.483C713.541 354.528 675.43 392.699 628.375 392.699C581.321 392.699 543.21 354.528 543.21 307.483C543.21 260.438 581.321 222.267 628.375 222.267C675.43 222.267 713.541 260.438 713.541 307.483Z"
          fill="url(#paint9_linear_3613_24200)"
        />
        <Path
          d="M628.375 219.111C677.062 219.111 716.658 258.73 716.658 307.446C716.658 356.162 677.062 395.781 628.375 395.781C579.688 395.781 540.055 356.162 540.055 307.446C540.055 258.73 579.651 219.111 628.375 219.111ZM628.375 217.217C578.538 217.217 538.163 257.616 538.163 307.483C538.163 357.35 578.538 397.749 628.375 397.749C678.213 397.749 718.587 357.35 718.587 307.483C718.587 257.616 678.213 217.217 628.375 217.217Z"
          fill="url(#paint10_linear_3613_24200)"
        />
        <Path
          d="M605.887 352.226C609.524 359.058 606.666 364.554 606.666 364.554C606.666 364.554 600.506 363.848 596.907 356.979C593.27 350.11 593.53 339.713 593.53 339.713C593.53 339.713 602.287 345.32 605.924 352.189L605.887 352.226Z"
          fill="url(#paint11_linear_3613_24200)"
        />
        <Path
          d="M595.422 369.678C603.178 369.678 606.666 364.591 606.666 364.591C606.666 364.591 603.178 359.467 595.422 359.467C587.666 359.467 578.575 364.516 578.575 364.516C578.575 364.516 587.629 369.641 595.385 369.641L595.422 369.678Z"
          fill="url(#paint12_linear_3613_24200)"
        />
        <Path
          d="M590.598 343.872C592.528 350.481 589.039 354.751 589.039 354.751C589.039 354.751 583.844 353.006 581.914 346.434C579.985 339.824 582.1 330.801 582.1 330.801C582.1 330.801 588.705 337.262 590.598 343.872Z"
          fill="url(#paint13_linear_3613_24200)"
        />
        <Path
          d="M578.315 357.127C585.032 358.538 589.039 354.751 589.039 354.751C589.039 354.751 586.924 349.664 580.17 348.253C573.416 346.842 564.622 349.627 564.622 349.627C564.622 349.627 571.561 355.716 578.315 357.127Z"
          fill="url(#paint14_linear_3613_24200)"
        />
        <Path
          d="M579.873 332.101C580.096 338.116 576.237 340.975 576.237 340.975C576.237 340.975 572.192 338.413 571.969 332.398C571.747 326.383 575.42 319.217 575.42 319.217C575.42 319.217 579.651 326.086 579.873 332.101Z"
          fill="url(#paint15_linear_3613_24200)"
        />
        <Path
          d="M566.663 340.715C572.081 343.351 576.237 340.975 576.237 340.975C576.237 340.975 575.532 336.223 570.114 333.586C564.696 330.95 556.68 331.433 556.68 331.433C556.68 331.433 561.282 338.079 566.663 340.678V340.715Z"
          fill="url(#paint16_linear_3613_24200)"
        />
        <Path
          d="M574.53 317.36C572.6 322.67 568.258 323.784 568.258 323.784C568.258 323.784 565.624 320.108 567.553 314.835C569.483 309.525 575.198 304.624 575.198 304.624C575.198 304.624 576.422 312.087 574.53 317.397V317.36Z"
          fill="url(#paint17_linear_3613_24200)"
        />
        <Path
          d="M560.02 320.182C563.805 324.378 568.258 323.784 568.258 323.784C568.258 323.784 569.297 319.402 565.549 315.206C561.764 311.011 554.602 308.597 554.602 308.597C554.602 308.597 556.272 315.986 560.02 320.182Z"
          fill="url(#paint18_linear_3613_24200)"
        />
        <Path
          d="M573.454 301.839C570.336 306.555 565.883 306.629 565.883 306.629C565.883 306.629 564.176 302.47 567.294 297.755C570.374 293.039 577.09 289.586 577.09 289.586C577.09 289.586 576.571 297.123 573.491 301.839H573.454Z"
          fill="url(#paint19_linear_3613_24200)"
        />
        <Path
          d="M558.721 301.208C561.393 306.146 565.883 306.629 565.883 306.629C565.883 306.629 567.924 302.619 565.215 297.643C562.506 292.705 556.124 288.695 556.124 288.695C556.124 288.695 556.012 296.269 558.721 301.208Z"
          fill="url(#paint20_linear_3613_24200)"
        />
        <Path
          d="M576.645 287.544C572.563 290.848 568.592 289.66 568.592 289.66C568.592 289.66 568.258 285.501 572.34 282.234C576.422 278.929 583.325 277.778 583.325 277.778C583.325 277.778 580.727 284.276 576.682 287.581L576.645 287.544Z"
          fill="url(#paint21_linear_3613_24200)"
        />
        <Path
          d="M563.731 282.865C564.733 287.989 568.555 289.66 568.555 289.66C568.555 289.66 571.487 286.69 570.485 281.566C569.483 276.441 564.956 271.095 564.956 271.095C564.956 271.095 562.729 277.741 563.731 282.902V282.865Z"
          fill="url(#paint22_linear_3613_24200)"
        />
        <Path
          d="M597.241 258.321C593.864 258.433 592.231 256.279 592.231 256.279C592.231 256.279 593.678 253.977 597.055 253.866C600.432 253.754 604.477 255.797 604.477 255.797C604.477 255.797 600.617 258.173 597.241 258.284V258.321Z"
          fill="url(#paint23_linear_3613_24200)"
        />
        <Path
          d="M592.416 250.895C590.932 253.94 592.268 256.279 592.268 256.279C592.268 256.279 594.94 255.871 596.424 252.826C597.909 249.781 597.649 245.251 597.649 245.251C597.649 245.251 593.901 247.85 592.453 250.895H592.416Z"
          fill="url(#paint24_linear_3613_24200)"
        />
        <Path
          d="M590.078 265.599C585.774 266.379 583.325 263.928 583.325 263.928C583.325 263.928 584.735 260.735 589.039 259.955C593.307 259.175 598.873 261.069 598.873 261.069C598.873 261.069 594.383 264.819 590.078 265.599Z"
          fill="url(#paint25_linear_3613_24200)"
        />
        <Path
          d="M582.508 257.022C581.172 261.181 583.325 263.928 583.325 263.928C583.325 263.928 586.664 262.926 588 258.767C589.299 254.608 588.149 248.853 588.149 248.853C588.149 248.853 583.881 252.863 582.545 257.022H582.508Z"
          fill="url(#paint26_linear_3613_24200)"
        />
        <Path
          d="M581.915 275.773C577.573 278.001 574.196 276.144 574.196 276.144C574.196 276.144 574.678 272.283 579.02 270.055C583.362 267.827 589.856 268.087 589.856 268.087C589.856 268.087 586.256 273.545 581.915 275.736V275.773Z"
          fill="url(#paint27_linear_3613_24200)"
        />
        <Path
          d="M571.079 269.015C571.004 273.879 574.159 276.144 574.159 276.144C574.159 276.144 577.387 273.991 577.461 269.127C577.536 264.262 574.418 258.507 574.418 258.507C574.418 258.507 571.153 264.151 571.042 269.015H571.079Z"
          fill="url(#paint28_linear_3613_24200)"
        />
        <Path
          d="M603.957 248.259C600.766 249.336 600.024 251.935 600.024 251.935C600.024 251.935 602.176 253.532 605.367 252.492C608.596 251.415 611.639 248.036 611.639 248.036C611.639 248.036 607.186 247.182 603.994 248.259H603.957Z"
          fill="url(#paint29_linear_3613_24200)"
        />
        <Path
          d="M650.863 352.226C647.227 359.058 650.084 364.554 650.084 364.554C650.084 364.554 656.244 363.848 659.881 356.979C663.48 350.11 663.258 339.713 663.258 339.713C663.258 339.713 654.5 345.32 650.863 352.189V352.226Z"
          fill="url(#paint30_linear_3613_24200)"
        />
        <Path
          d="M661.365 369.678C653.609 369.678 650.084 364.591 650.084 364.591C650.084 364.591 653.572 359.467 661.328 359.467C669.084 359.467 678.138 364.516 678.138 364.516C678.138 364.516 669.084 369.641 661.328 369.641L661.365 369.678Z"
          fill="url(#paint31_linear_3613_24200)"
        />
        <Path
          d="M666.152 343.872C664.223 350.481 667.711 354.751 667.711 354.751C667.711 354.751 672.906 353.006 674.873 346.434C676.803 339.824 674.687 330.801 674.687 330.801C674.687 330.801 668.082 337.262 666.152 343.872Z"
          fill="url(#paint32_linear_3613_24200)"
        />
        <Path
          d="M678.435 357.127C671.719 358.538 667.711 354.751 667.711 354.751C667.711 354.751 669.826 349.664 676.58 348.253C683.334 346.842 692.129 349.627 692.129 349.627C692.129 349.627 685.189 355.716 678.435 357.127Z"
          fill="url(#paint33_linear_3613_24200)"
        />
        <Path
          d="M676.877 332.101C676.654 338.116 680.514 340.975 680.514 340.975C680.514 340.975 684.558 338.413 684.781 332.398C685.004 326.383 681.33 319.217 681.33 319.217C681.33 319.217 677.099 326.086 676.877 332.101Z"
          fill="url(#paint34_linear_3613_24200)"
        />
        <Path
          d="M690.088 340.715C684.67 343.351 680.513 340.975 680.513 340.975C680.513 340.975 681.219 336.223 686.636 333.586C692.017 330.95 700.07 331.433 700.07 331.433C700.07 331.433 695.468 338.079 690.051 340.678L690.088 340.715Z"
          fill="url(#paint35_linear_3613_24200)"
        />
        <Path
          d="M682.221 317.36C684.15 322.67 688.492 323.784 688.492 323.784C688.492 323.784 691.09 320.108 689.197 314.835C687.267 309.525 681.553 304.624 681.553 304.624C681.553 304.624 680.328 312.087 682.221 317.397V317.36Z"
          fill="url(#paint36_linear_3613_24200)"
        />
        <Path
          d="M696.73 320.182C692.945 324.378 688.492 323.784 688.492 323.784C688.492 323.784 687.453 319.402 691.201 315.206C694.986 311.011 702.148 308.597 702.148 308.597C702.148 308.597 700.478 315.986 696.73 320.182Z"
          fill="url(#paint37_linear_3613_24200)"
        />
        <Path
          d="M683.297 301.839C686.414 306.555 690.867 306.629 690.867 306.629C690.867 306.629 692.574 302.47 689.494 297.755C686.414 293.039 679.697 289.586 679.697 289.586C679.697 289.586 680.217 297.123 683.297 301.839Z"
          fill="url(#paint38_linear_3613_24200)"
        />
        <Path
          d="M698.066 301.208C695.357 306.146 690.904 306.629 690.904 306.629C690.904 306.629 688.863 302.619 691.572 297.643C694.281 292.705 700.701 288.695 700.701 288.695C700.701 288.695 700.775 296.269 698.103 301.208H698.066Z"
          fill="url(#paint39_linear_3613_24200)"
        />
        <Path
          d="M680.142 287.544C684.187 290.848 688.195 289.66 688.195 289.66C688.195 289.66 688.529 285.501 684.447 282.234C680.402 278.929 673.463 277.778 673.463 277.778C673.463 277.778 676.06 284.276 680.105 287.581L680.142 287.544Z"
          fill="url(#paint40_linear_3613_24200)"
        />
        <Path
          d="M693.019 282.865C692.017 287.989 688.195 289.66 688.195 289.66C688.195 289.66 685.263 286.69 686.265 281.566C687.267 276.441 691.795 271.095 691.795 271.095C691.795 271.095 694.021 277.741 693.019 282.902V282.865Z"
          fill="url(#paint41_linear_3613_24200)"
        />
        <Path
          d="M659.51 258.321C662.887 258.433 664.519 256.279 664.519 256.279C664.519 256.279 663.072 253.977 659.695 253.866C656.318 253.754 652.311 255.797 652.311 255.797C652.311 255.797 656.17 258.173 659.547 258.284L659.51 258.321Z"
          fill="url(#paint42_linear_3613_24200)"
        />
        <Path
          d="M664.371 250.895C665.855 253.94 664.519 256.279 664.519 256.279C664.519 256.279 661.848 255.871 660.363 252.826C658.879 249.781 659.139 245.251 659.139 245.251C659.139 245.251 662.887 247.85 664.334 250.895H664.371Z"
          fill="url(#paint43_linear_3613_24200)"
        />
        <Path
          d="M666.709 265.599C671.014 266.379 673.463 263.928 673.463 263.928C673.463 263.928 672.053 260.735 667.748 259.955C663.443 259.175 657.914 261.069 657.914 261.069C657.914 261.069 662.404 264.819 666.709 265.599Z"
          fill="url(#paint44_linear_3613_24200)"
        />
        <Path
          d="M674.279 257.022C675.615 261.181 673.463 263.928 673.463 263.928C673.463 263.928 670.123 262.926 668.787 258.767C667.451 254.608 668.639 248.853 668.639 248.853C668.639 248.853 672.943 252.863 674.242 257.022H674.279Z"
          fill="url(#paint45_linear_3613_24200)"
        />
        <Path
          d="M674.836 275.773C679.177 278.001 682.554 276.144 682.554 276.144C682.554 276.144 682.072 272.283 677.73 270.055C673.388 267.827 666.894 268.087 666.894 268.087C666.894 268.087 670.494 273.545 674.836 275.736V275.773Z"
          fill="url(#paint46_linear_3613_24200)"
        />
        <Path
          d="M685.672 269.015C685.746 273.879 682.592 276.144 682.592 276.144C682.592 276.144 679.363 273.991 679.289 269.127C679.215 264.262 682.332 258.507 682.332 258.507C682.332 258.507 685.635 264.151 685.709 269.015H685.672Z"
          fill="url(#paint47_linear_3613_24200)"
        />
        <Path
          d="M652.793 248.259C655.984 249.336 656.727 251.935 656.727 251.935C656.727 251.935 654.574 253.532 651.383 252.492C648.154 251.415 645.148 248.036 645.148 248.036C645.148 248.036 649.602 247.182 652.793 248.259Z"
          fill="url(#paint48_linear_3613_24200)"
        />
        <Path
          d="M664.59 297.049H634.543L638.406 305.509H647.293V324.529H655.777V305.509H664.59V297.049Z"
          fill="#FCFCFC"
        />
        <Path
          d="M619.165 297.049H594.903V305.509H606.603L594.903 316.069V324.529H619.165V316.069H607.464L619.165 305.509V297.049Z"
          fill="#FCFCFC"
        />
        <Path
          d="M641.245 316.069H628.876V314.612H640.558L638.35 309.852L637.007 306.966H628.876V305.509H636.253L632.39 297.049H628.876H621.105V305.509V306.966V314.612V316.069V324.529H628.876H645.182L641.245 316.069Z"
          fill="#FCFCFC"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_3613_24200"
          x1={628.926}
          y1={696.469}
          x2={628.926}
          y2={179.529}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="white" />
          <Stop offset={0.36} stopColor="#F1F1F1" />
          <Stop offset={1} stopColor="#CFCFCF" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_3613_24200"
          x1={1069.3}
          y1={276.813}
          x2={1425.73}
          y2={726.154}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D1D1D1" />
          <Stop offset={0.14} stopColor="#C9C9C9" />
          <Stop offset={0.35} stopColor="#B5B5B5" />
          <Stop offset={0.6} stopColor="#959595" />
          <Stop offset={0.89} stopColor="#676767" />
          <Stop offset={1} stopColor="#545454" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_3613_24200"
          x1={172.001}
          y1={276.813}
          x2={-184.432}
          y2={726.154}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D1D1D1" />
          <Stop offset={0.14} stopColor="#C9C9C9" />
          <Stop offset={0.35} stopColor="#B5B5B5" />
          <Stop offset={0.6} stopColor="#959595" />
          <Stop offset={0.89} stopColor="#676767" />
          <Stop offset={1} stopColor="#545454" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_3613_24200"
          x1={646.664}
          y1={608.097}
          x2={646.664}
          y2={-678.98}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint4_linear_3613_24200"
          x1={646.664}
          y1={-169.578}
          x2={646.664}
          y2={321.259}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#005E8A" />
          <Stop offset={0.01} stopColor="#005C88" />
          <Stop offset={0.3} stopColor="#003C65" />
          <Stop offset={0.56} stopColor="#00264C" />
          <Stop offset={0.8} stopColor="#00183D" />
          <Stop offset={1} stopColor="#001438" />
        </LinearGradient>
        <LinearGradient
          id="paint5_linear_3613_24200"
          x1={-85.3506}
          y1={-331.173}
          x2={-81.6353}
          y2={301.468}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#005E8A" />
          <Stop offset={0.01} stopColor="#005C88" />
          <Stop offset={0.3} stopColor="#003C65" />
          <Stop offset={0.56} stopColor="#00264C" />
          <Stop offset={0.8} stopColor="#00183D" />
          <Stop offset={1} stopColor="#001438" />
        </LinearGradient>
        <LinearGradient
          id="paint6_linear_3613_24200"
          x1={628.926}
          y1={27.4028}
          x2={628.926}
          y2={878.412}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B27F2A" />
          <Stop offset={0.06} stopColor="#B6852E" />
          <Stop offset={0.14} stopColor="#C49839" />
          <Stop offset={0.24} stopColor="#D9B74B" />
          <Stop offset={0.33} stopColor="#F4DD62" />
          <Stop offset={0.52} stopColor="#F4E38B" />
          <Stop offset={0.66} stopColor="#F4DD62" />
          <Stop offset={1} stopColor="#B27F2A" />
        </LinearGradient>
        <LinearGradient
          id="paint7_linear_3613_24200"
          x1={695.172}
          y1={212.465}
          x2={562.29}
          y2={401.239}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint8_linear_3613_24200"
          x1={557.126}
          y1={227.651}
          x2={698.419}
          y2={385.747}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint9_linear_3613_24200"
          x1={591.786}
          y1={344.094}
          x2={744.506}
          y2={191.427}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#001438" />
          <Stop offset={0.2} stopColor="#00183D" />
          <Stop offset={0.44} stopColor="#00264C" />
          <Stop offset={0.7} stopColor="#003C65" />
          <Stop offset={0.99} stopColor="#005C88" />
          <Stop offset={1} stopColor="#005E8A" />
        </LinearGradient>
        <LinearGradient
          id="paint10_linear_3613_24200"
          x1={538.163}
          y1={307.483}
          x2={718.587}
          y2={307.483}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint11_linear_3613_24200"
          x1={593.493}
          y1={352.152}
          x2={607.742}
          y2={352.152}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint12_linear_3613_24200"
          x1={578.575}
          y1={364.554}
          x2={606.666}
          y2={364.554}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint13_linear_3613_24200"
          x1={581.098}
          y1={342.758}
          x2={591.192}
          y2={342.758}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint14_linear_3613_24200"
          x1={564.659}
          y1={352.634}
          x2={589.039}
          y2={352.634}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint15_linear_3613_24200"
          x1={571.969}
          y1={330.096}
          x2={579.873}
          y2={330.096}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint16_linear_3613_24200"
          x1={556.643}
          y1={336.668}
          x2={576.237}
          y2={336.668}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint17_linear_3613_24200"
          x1={566.848}
          y1={314.204}
          x2={575.606}
          y2={314.204}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint18_linear_3613_24200"
          x1={554.602}
          y1={316.209}
          x2={568.37}
          y2={316.209}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint19_linear_3613_24200"
          x1={565.401}
          y1={298.126}
          x2={577.09}
          y2={298.126}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint20_linear_3613_24200"
          x1={556.087}
          y1={297.68}
          x2={566.588}
          y2={297.68}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint21_linear_3613_24200"
          x1={568.555}
          y1={283.831}
          x2={583.288}
          y2={283.831}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint22_linear_3613_24200"
          x1={563.508}
          y1={280.34}
          x2={570.708}
          y2={280.34}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint23_linear_3613_24200"
          x1={592.231}
          y1={256.131}
          x2={604.477}
          y2={256.131}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint24_linear_3613_24200"
          x1={591.711}
          y1={250.784}
          x2={597.612}
          y2={250.784}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint25_linear_3613_24200"
          x1={583.288}
          y1={262.777}
          x2={598.873}
          y2={262.777}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint26_linear_3613_24200"
          x1={582.063}
          y1={256.391}
          x2={588.594}
          y2={256.391}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint27_linear_3613_24200"
          x1={574.196}
          y1={272.468}
          x2={589.856}
          y2={272.468}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint28_linear_3613_24200"
          x1={571.079}
          y1={267.307}
          x2={577.499}
          y2={267.307}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint29_linear_3613_24200"
          x1={600.024}
          y1={250.301}
          x2={611.639}
          y2={250.301}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint30_linear_3613_24200"
          x1={649.008}
          y1={352.152}
          x2={663.258}
          y2={352.152}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint31_linear_3613_24200"
          x1={650.084}
          y1={364.554}
          x2={678.176}
          y2={364.554}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint32_linear_3613_24200"
          x1={665.596}
          y1={342.758}
          x2={675.652}
          y2={342.758}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint33_linear_3613_24200"
          x1={667.711}
          y1={352.634}
          x2={692.129}
          y2={352.634}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint34_linear_3613_24200"
          x1={676.877}
          y1={330.096}
          x2={684.818}
          y2={330.096}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint35_linear_3613_24200"
          x1={680.513}
          y1={336.668}
          x2={700.107}
          y2={336.668}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint36_linear_3613_24200"
          x1={681.181}
          y1={314.204}
          x2={689.902}
          y2={314.204}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint37_linear_3613_24200"
          x1={688.381}
          y1={316.209}
          x2={702.185}
          y2={316.209}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint38_linear_3613_24200"
          x1={679.66}
          y1={298.126}
          x2={691.349}
          y2={298.126}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint39_linear_3613_24200"
          x1={690.162}
          y1={297.68}
          x2={700.664}
          y2={297.68}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint40_linear_3613_24200"
          x1={673.5}
          y1={283.831}
          x2={688.195}
          y2={283.831}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint41_linear_3613_24200"
          x1={686.043}
          y1={280.34}
          x2={693.242}
          y2={280.34}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint42_linear_3613_24200"
          x1={652.273}
          y1={256.131}
          x2={664.519}
          y2={256.131}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint43_linear_3613_24200"
          x1={659.139}
          y1={250.784}
          x2={665.076}
          y2={250.784}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint44_linear_3613_24200"
          x1={657.914}
          y1={262.777}
          x2={673.463}
          y2={262.777}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint45_linear_3613_24200"
          x1={668.156}
          y1={256.391}
          x2={674.687}
          y2={256.391}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint46_linear_3613_24200"
          x1={666.894}
          y1={272.468}
          x2={682.554}
          y2={272.468}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint47_linear_3613_24200"
          x1={679.252}
          y1={267.307}
          x2={685.672}
          y2={267.307}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
        <LinearGradient
          id="paint48_linear_3613_24200"
          x1={645.148}
          y1={250.301}
          x2={656.764}
          y2={250.301}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#B2782A" />
          <Stop offset={0.06} stopColor="#B67E2E" />
          <Stop offset={0.14} stopColor="#C49139" />
          <Stop offset={0.24} stopColor="#D9B04B" />
          <Stop offset={0.33} stopColor="#F4D662" />
          <Stop offset={0.52} stopColor="#F4DE8B" />
          <Stop offset={0.66} stopColor="#F4D662" />
          <Stop offset={1} stopColor="#B2782A" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export default TrainingCertificate
